import { NgClass } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { environment } from '@environments/environment';
import { InHomeBookingResult, Result } from '@Medology/ng-findalab';
import { PhoneService } from '@services/phone.service';

@Component({
  selector: 'app-selected-center-card',
  templateUrl: './selected-center-card.component.html',
  styleUrls: ['./selected-center-card.component.scss'],
  imports: [NgClass],
})
export class SelectedCenterCardComponent {
  @Input() public label: string = 'Lab';
  @Input() public noSelectedCenterLabel: string = 'No location has been set.';
  @Input() public center: Result;
  @Input() public inHomeResult: InHomeBookingResult;
  @Input() public displayChangeLocationBtn: boolean = true;
  @Output() private changeCenterEvent: EventEmitter<any> = new EventEmitter<any>();

  private phoneService = inject(PhoneService);

  /**
   * Gets the booking date and time in a format like MM/DD/YYYY
   */
  public get bookingDate(): string | null {
    if (!this.inHomeResult) {
      return null;
    }

    const dateSegments = this.inHomeResult.date.split('-');

    return dateSegments[1] + '/' + dateSegments[2] + '/' + dateSegments[0];
  }

  /**
   * Gets the change button text based on environment.
   */
  public get changeButtonText(): string {
    return environment.buttons.selectedCenterChange;
  }

  /**
   * Emit change center event
   */
  public changeCenter(): void {
    this.changeCenterEvent.emit();
  }

  /**
   * Format the phone number with hyphens separating each part.
   *
   * @param phoneNumber phone number as string
   * @returns the phone number with each part separated by hyphens
   */
  public formatPhoneNumber(phoneNumber: string): string {
    return this.phoneService.formatPhoneNumber(phoneNumber);
  }
}
